var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('div',{staticClass:"left"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }